// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import OrganizationEditScreen from "../../src/screens/organizations/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} OrganizationNewRouteProps */

/** @typedef {Record<string, never>} OrganizationNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<OrganizationNewRouteProps, OrganizationNewRouteState>}
 */
class OrganizationNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New organization")}</ScreenTitle>
        <OrganizationEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<OrganizationNewRouteProps>} */
const OrganizationNewRouteComponent = memo(shapeComponent(OrganizationNewRoute))

export default OrganizationNewRouteComponent
